export const FOUR_DOT_FUSION_METRIC_QUERY = `
fourDotFusion {
    metrics {
       fourDotFusionResult
    }
}
`;
